import { render, staticRenderFns } from "./FeedbackContainer.vue?vue&type=template&id=4f0cf056"
import script from "./FeedbackContainer.vue?vue&type=script&lang=ts"
export * from "./FeedbackContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports